module.exports = __webpack_public_path__ + "static/project-history-3x-6ed371ac7d48c29d6767f1460132b9ba.jpg";